import DigitalProductTypes from '@/constants/digitalProductTypes';

export const apiPaths = {
  cart: {
    hydrate: '/api/cart/hydrate',
  },
  localization: {
    areaVars: '/api/localization/area-vars',
    countries: '/api/localization/countries',
  },
  payments: {
    mollie: {
      index: '/api/payments/mollie',
    },
    methods: '/api/payments/methods',
  },
  devices: {
    remoteAccess: {
      getByOrderId: `/api/device-details/${DigitalProductTypes.RemoteAccess}/get-by-order-id`,
      validate: `/api/device-details/${DigitalProductTypes.RemoteAccess}`,
    },
    guaranteePlus: {
      getByOrderId: `/api/device-details/${DigitalProductTypes.GuaranteePlus}/get-by-order-id`,
      validate: `/api/device-details/${DigitalProductTypes.GuaranteePlus}`,
    },
    smartHosting: {
      getByOrderId: `/api/device-details/${DigitalProductTypes.SmartHosting}/get-by-order-id`,
      validate: `/api/device-details/${DigitalProductTypes.SmartHosting}`,
    },
    upgrade: {
      isEligible: '/api/device-details/upgrade/is-eligible',
    },
  },
  customers: {
    getCustomerById: '/api/customers/get',
    isCustomer: '/api/customers/is-customer?email=',
    isClubMember: '/api/customers/is-club-member',
    nukiClubSignup: '/api/customers/nuki-club-signup?',
    updateCustomerById: '/api/customers/update',
    revokeSession: '/api/customers/revoke-session',
    registerViaNukiClub: '/api/customers/register-via-nuki-club',
  },
  orders: {
    cancel: '/api/cancel-order',
    cancelExtended: '/api/cancel-order-extended',
    return: {
      create: '/api/customers/orders/return/create',
      reason: '/api/customers/orders/return/reason/get',
      type: '/api/customers/orders/return/type/get',
    },
  },
  myDevices: {
    removeMyDevice: '/api/customers/my-devices/remove',
    addMyDevice: '/api/customers/my-devices/add',
    getMyDevices: '/api/customers/my-devices/get',
  },
  myServices: {
    getServices: '/api/customers/my-services/get',
    connectService: '/api/customers/my-services/connect',
    cancelService: '/api/customers/my-services/cancel',
    changeSubscriptionBillingAddress:
      '/api/customers/my-services/change-subscription-billing-address',
  },
  opener: {
    storeCheckResults: '/api/opener/store-check-results',
    storeModelNotFoundResults: '/api/opener/store-model-not-found-customer',
  },
  findYourSolution: {
    storeAnswer: '/api/find-your-solution/store-answer',
  },
  clubSurvey: {
    storeAnswer: '/api/club-survey/store-answer',
  },
  metadata: {
    trackConversions: '/api/metadata/conversions',
  },
  forms: {
    'b2b-form': '/api/forms/b2b-form',
    'generic-form': '/api/forms/generic-form',
  },
  communication: {
    backInStock: '/api/communication/back-in-stock',
  },
};
